import React, { Component } from "react";
import Layout from "../../components/Layout";
import Meta from "../../components/Meta";
import MenuNL from "../../components/nl/MenuNL";
import FooterNL from "../../components/nl/FooterNL";

class Index extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Layout>
                <Meta
                    title={"Advies, verdediging en geschillen — Advocaten in Mechelen"}
                    description={"Administratief recht, bestuursrecht, bedrijfsrecht, fiscaal recht, burgerlijk recht en strafrecht – we adviseren en verdedigen particulieren en ondernemingen"}
                    url={"https://www.coeladvocaten.be/nl/nl/advies-verdediging-geschillen"}
                    robots={"index, follow"}
                    languages={[
                        { url:"https://www.coeladvocaten.be/nl/advies-verdediging-geschillen", language:"nl" },
                        { url:"https://www.coeladvocaten.be/fr/conseils-defense-litiges", language:"fr" },
                        { url:"https://www.coeladvocaten.be/en/advice-defense-disputes", language:"en" }
                    ]}
                />

                <MenuNL
                    switchUrlFR="/fr/conseils-defense-litiges"
                    switchUrlEN="/en/advice-defense-disputes"
                />

                <div className="page">
                    <div className="header">
                        <div className="grayscale background background-conseils-defense-litiges"></div>
                        <div className="slider">
                            <h1>Onze diensten</h1>
                            <h2>Advies, verdediging en geschillen</h2>
                            <p></p>
                            <a href="/nl/contact" alt="contact" className="button">info@coeladvocaten.be</a>
                        </div>
                    </div>

                    <div className="content">
                        <div className="container press">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slider">
                                        <div className="margin-top">
                                            <p></p>
                                            <p>Onze advocaten bieden hun unieke expertise om u te adviseren en uw belangen te verdedigen in de volgende domeinen.</p>
                                            <p>Administratief recht bestuurs- en ambtenarenrecht</p>
                                            <p><b>Verdediging van particulieren en ondernemingen tegen beslissingen van overheidsinstanties, op eender welk niveau. Van de herziening van een arbitrageprocedure tot de nietigverklaring van een beslissing door de Raad van State.</b></p>
                                            <p>-	Administratieve geschillen: weigering of herroeping van machtigingen of licenties, weigering van een huwelijk of van binnenkomst op het grondgebied, enz.</p>
                                            <p>-	Geschillen over benoemings- en ontslagprocedures bij statutair en contractueel personeel </p>
                                            <p><b>Bedrijfsrecht</b></p>
                                            <p>Advies en verdediging voor alle aangelegenheden met betrekking tot ondernemingen:</p>
                                            <p>-	Startups en oprichting van bedrijven: haalbaarheidsstudies en voorspellingen, keuze van de ondernemingsvorm, opstellen van het financieel plan, inschrijven bij een sociaal secretariaat, inschrijven in de KBO (Kruispuntbank van Ondernemingen), activatie van het btw-nummer, optimalisatie van sociale bijdragen en inkomen enz.</p>
                                            <p>-	Geschillen tussen vennoten</p>
                                            <p>-	Fusies en overnames</p>
                                            <p>-	Reorganisaties, liquidaties en faillissementen</p>
                                            <p><b>Fiscaal recht</b></p>
                                            <p>Advies en verdediging voor particulieren en ondernemingen:</p>
                                            <p>-	Fiscaliteit van personen en bedrijven: personenbelasting, bedrijfsbelasting, vennootschapsbelasting, belastingheffing van niet-ingezetenen, btw enz.</p>
                                            <p>-	Registratierechten en hypotheken</p>
                                            <p>-	Erfrecht en (inter)nationale successieplanning</p>
                                            <p>-	Regionale en lokale belastingen</p>
                                            <p>-	Europees en internationaal fiscaal recht</p>
                                            <p>-	Fiscale procedures</p>
                                            <p>-	Verzoek om voorafgaande beslissingen, op Vlaams en federaal niveau</p>
                                            <p>-	Beheersmaatschappijen en patrimoniumvennootschappen</p>
                                            <p>-	Grensoverschrijdende fiscaliteit en preventieve dubbelbelastingverdragen</p>
                                            <p>-	Aankopen van tweede verblijven in het buitenland (met inbegrip van Spanje)</p>
                                            <p><b>Burgerlijk recht</b></p>
                                            <p>Advies en verdediging voor particulieren en ondernemingen, in het bijzonder met betrekking tot handelshuurovereenkomsten en landbouwrecht:</p>
                                            <p>-	Erfdienstbaarheden</p>
                                            <p>-	Land(bouw)pachtovereenkomsten </p>
                                            <p>-	Huurovereenkomsten en commerciële huurovereenkomsten</p>
                                            <p>-	Onteigeningen</p>
                                            <p><b>Strafrecht</b></p>
                                            <p>Advies en verdediging voor particulieren en ondernemingen in alle zaken met betrekking tot het strafrecht: politierechtbank, rechtbank van eerste aanleg tot aan het Hof van Cassatie, als gedaagde en als burgerlijke partij.</p>
                                            <p>CTA : Nood aan advies of verdediging?</p>
                                            <p><br /></p>
                                            <p className="text-center"><a href="/nl/contact" alt="contact" className="button">info@coeladvocaten.be</a></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row"><br /><br /></div>
                        </div>
                    </div>
                </div>

                <FooterNL />
            </Layout>
        );
    }
}

export default Index;
